import { getComposeStore } from '../selectors/getComposeStore';
import type {
    ComposeViewState,
    FullComposeViewState,
    QuickComposeViewState,
    MetricsInfo,
    AttachmentFiles,
} from 'owa-calendar-compose-types';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    ComposeFormType,
    FULL_COMPOSE_FORM_TYPE,
    QUICK_COMPOSE_FORM_TYPE,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';

export function getComposeViewState(formId: string): ComposeViewState | null {
    const store = getComposeStore(formId);

    return store?.uiState ? (store?.uiState as ComposeViewState) : null;
}

export function getFullComposeViewState(formId: string): FullComposeViewState | null {
    const openedForm = getOpenedForm(formId);

    // Note: openedForm can be null but the view state still valid
    // if the form is closed for undo
    if (openedForm == FULL_COMPOSE_FORM_TYPE || openedForm == null) {
        const viewState = getComposeViewState(formId);

        if (viewState) {
            return viewState as FullComposeViewState;
        }
    }

    return null;
}

export function getQuickComposeViewState(formId: string): QuickComposeViewState | null {
    const openedForm = getOpenedForm(formId);

    // Note: openedForm can be null but the view state still valid
    // if the form is closed for undo
    if (openedForm == QUICK_COMPOSE_FORM_TYPE || openedForm == null) {
        const viewState = getComposeViewState(formId);

        if (viewState) {
            return viewState as QuickComposeViewState;
        }
    }

    return null;
}

export function getOriginalEvent(formId: string): CalendarEvent | null {
    return getComposeStore(formId)?.originalEvent ?? null;
}

export function getComposeEvent(formId: string): CalendarEvent | null {
    return getComposeStore(formId)?.event ?? null;
}

export function getOpenedForm(formId: string): ComposeFormType | null {
    return getComposeStore(formId)?.openedForm ?? null;
}

export function getMetricsInfo(formId: string): MetricsInfo | null {
    return getComposeStore(formId)?.metricsInfo ?? null;
}

export function getAttachmentFiles(formId: string): AttachmentFiles | null {
    return getComposeStore(formId)?.attachmentFiles ?? null;
}
